import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Aor } from 'components'
import {
  OrderSummary,
  NextStepsContent,
  OrderConfirmationContent,
} from 'member-portal/components'
import { selectors as memberSelectors } from 'member-reducer'
import * as apiActions from 'api-actions'
import * as memberActions from 'member-actions'
import { MembershipType, AppliedDiscountCodeType, BillingType } from 'types'
import {
  PATH,
  makeMemberPortalPath,
  NEXT_STEPS_CONTENT,
  ORDER_CONFIRMATION_CONTENT,
} from 'config'
import { formatUSMonthDayYearDateString, withApiAuth } from 'utils'

const propTypes = {
  billing: BillingType,
  clearShoppingCart: PropTypes.func.isRequired,
  discountCodeDetails: AppliedDiscountCodeType,
  fetchAllMembershipsForAccount: PropTypes.func.isRequired,
  isTrialMembershipsActive: PropTypes.bool,
  membership: MembershipType,
  promoCodeIsTrial: PropTypes.bool,
  trialDuration: PropTypes.number,
}

function RenewalConfirmation({
  billing,
  clearShoppingCart,
  discountCodeDetails,
  fetchAllMembershipsForAccount,
  isTrialMembershipsActive = false,
  membership,
  promoCodeIsTrial = false,
  trialDuration,
}) {
  const history = useHistory()

  const {
    aor,
    apple_pass__c: applePassUrl,
    google_pass__c: googlePassUrl,
    membership_number__c: membershipNumber,
    membership_expiration_date__c: membershipExpirationDate,
    membership_type__c: membershipType,
    account__c: accountId,
  } = membership
  const formattedExpirationDate = formatUSMonthDayYearDateString(
    membershipExpirationDate,
  )

  const goToMemberPortal = async () => {
    await fetchAllMembershipsForAccount(accountId)
    clearShoppingCart()
    history.push(makeMemberPortalPath(PATH.ROOT))
  }

  return (
    <div className="form-with-aside-wrapper form-block-container confirmation">
      <div className="form-with-aside-block confirmation">
        <div className="form-with-aside">
          <div className="card card-medium">
            <OrderConfirmationContent
              isAutoRenewEnabled={billing?.autoRenewalAgreement}
              title={ORDER_CONFIRMATION_CONTENT.MEMBER_RENEWAL.title}
              description={
                ORDER_CONFIRMATION_CONTENT.MEMBER_RENEWAL.description
              }
              membershipNumber={membershipNumber}
              expirationDate={formattedExpirationDate}
              applePassUrl={applePassUrl}
              googlePassUrl={googlePassUrl}
            />
          </div>

          <div className="card card-medium">
            <OrderSummary
              billing={billing}
              discountCodeDetails={discountCodeDetails}
              isTrialMembershipsActive={isTrialMembershipsActive}
              membershipType={membershipType}
              promoCodeIsTrial={promoCodeIsTrial}
              trialDuration={trialDuration}
            />
          </div>

          <div className="card card-medium confirmation-card">
            <NextStepsContent
              boats_info={NEXT_STEPS_CONTENT.MEMBER_RENEWAL.boats_info}
              buttonText={NEXT_STEPS_CONTENT.MEMBER_RENEWAL.buttonText}
              confirmationHandler={goToMemberPortal}
              description={NEXT_STEPS_CONTENT.MEMBER_RENEWAL.description}
              title={NEXT_STEPS_CONTENT.MEMBER_RENEWAL.title}
            />
          </div>
        </div>

        <aside>
          <div className="card image-card">
            <Aor aor={aor} />
          </div>
        </aside>
      </div>
    </div>
  )
}

RenewalConfirmation.propTypes = propTypes

function mapStateToProps(state) {
  return {
    billing: memberSelectors.billing(state),
    discountCodeDetails: memberSelectors.discountCodeDetails(state),
    membership: memberSelectors.membership(state),
  }
}

const mapDispatchToProps = {
  clearShoppingCart: memberActions.clearShoppingCart,
}

const mapApiAuthToProps = {
  fetchAllMembershipsForAccount: apiActions.fetchAllMembershipsForAccount,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withApiAuth(mapApiAuthToProps),
)(RenewalConfirmation)
